// 클래스 - 본사 - 지사별 통계
import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from "react";

import axios from '@app/lib/axios';

import ReactEcharts from "echarts-for-react";
import CommonHorizontalBarChart from "@app/components/CommonHorizontalBarChart";

import flyengStyle from "../../components/style";

const NurseryContentNursery = forwardRef(({ statPeriod, branchId, branchName, nurseryId, nurseryName, updateViewSubOption }, ref) => {
    const [loadingData, setLoadingData] = useState(false);
    const [stat, setStat] = useState(false);
    const [statAge, setStatAge] = useState(false);
    const [statOs, setStatOs] = useState(false);
    const [statContent, setStatContent] = useState(false);
    const [statContentSum, setStatContentSum] = useState(false);

    useImperativeHandle(ref, () => ({
        getExcelData(callback) {
            const excelData = {
                fileName: "플라잉클래스_원통계",
                sheets: [
                    {
                        name: "접속",
                        title: `${nurseryName} - 접속 통계`,
                        columnTitle: ["연령", "안드로이드", "웹"],
                        data: statAge ? statAge.map((s) => [s.name, s.osAndroid, s.osWeb]) : [],
                    },
                    {
                        name: "연령",
                        title: `${nurseryName} - 연령별 콘텐츠 사용 통계`,
                        columnTitle: ["연령", "교실영어(순)", "스페셜(순)", "교실영어(누적)", "스페셜(누적)"],
                        data: statAge ? statAge.map((s) => [s.name, s.playCountClass, s.playCountSpecial, s.playCountClassSum, s.playCountSpecialSum]) : [],
                    },
                ],
            };
            callback(null, excelData);
        },
    }));
    const getStat = useCallback(() => {
        setLoadingData(true);
        axios({
            method: "POST",
            url: `/api/flyeng_stat/new/class/branch/${branchId}/nursery/${nurseryId}/content`,
            data: {
                start: statPeriod.startDate,
                end: statPeriod.endDate,
                periodType: statPeriod.type,
            },
        })
            .then((result) => {
                if (result.data.code === 200) {
                    const stat = result.data.data;
                    var statAge = [
                            { id: "0", name: "만2세" },
                            { id: "1", name: "만3세" },
                            { id: "2", name: "만4세" },
                            { id: "3", name: "만5세" },
                        ],
                        statOs = [
                            { id: "android", name: "안드로이드", value: 0 },
                            { id: "web", name: "웹", value: 0 },
                        ],
                        statContent = [
                            { id: 0, name: "교실영어(순)", value: 0 },
                            { id: 1, name: "스페셜(순)", value: 0 },
                        ],
                        statContentSum = [
                            { id: 0, name: "교실영어(누적)", value: 0 },
                            { id: 1, name: "스페셜(누적)", value: 0 },
                        ];
                    stat.forEach((s) => {
                        statAge[s.age] = { ...statAge[s.age], ...s };
                    });
                    statOs[0].value = stat.reduce((ac, current) => ac + (current.osAndroid ? current.osAndroid : 0), 0);
                    statOs[1].value = stat.reduce((ac, current) => ac + (current.osWeb ? current.osWeb : 0), 0);
                    statOs[0].value = stat.reduce((ac, current) => ac + (current.osAndroid ? current.osAndroid : 0), 0);
                    statOs[1].value = stat.reduce((ac, current) => ac + (current.osWeb ? current.osWeb : 0), 0);
                    statContent[0].value = stat.reduce((ac, current) => ac + (current.playCountClass ? current.playCountClass : 0), 0);
                    statContent[1].value = stat.reduce((ac, current) => ac + (current.playCountSpecial ? current.playCountSpecial : 0), 0);
                    statContentSum[0].value = stat.reduce((ac, current) => ac + (current.playCountClassSum ? current.playCountClassSum : 0), 0);
                    statContentSum[1].value = stat.reduce((ac, current) => ac + (current.playCountSpecialSum ? current.playCountSpecialSum : 0), 0);

                    setStat(stat);
                    setStatAge(statAge);
                    setStatOs(statOs);
                    setStatContent(statContent);
                    setStatContentSum(statContentSum);
                } else {
                    alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                }
                setLoadingData(false);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                setLoadingData(false);
            });
    }, [statPeriod]);
    useEffect(() => {
        getStat();
        return () => {};
    }, [getStat]);

    const optionOs = {
        tooltip: {
            trigger: "item",
            formatter: (param) => {
                return param.data ? param.data.name + " : " + param.data.value.toLocaleString() + " (" + Math.ceil(param.percent) + "%)" : "";
            },
        },
        series: {
            type: "pie",
            data: statOs,
            radius: "95%",
            animation: false,
            center: ["35%", "50%"],
            labelLine: {
                show: false,
            },
            label: {
                show: false,
                position: "center",
            },
        },
        legend: {
            show: true,
            data: ["안드로이드", "웹"],
            x: "right",
            y: "bottom",
            orient: "vertical",
            align: "left",
            formatter: (name) => {
                const s = statOs.find((s) => s.name === name);
                if (s) {
                    return `${name} - ${s.value}`;
                }
                return name;
            },
        },
        color: ["#60d7c5", "#b9ed4a"],
    };
    const optionContent = {
        tooltip: {
            trigger: "item",
            formatter: (param) => {
                return param.data ? param.data.name + " : " + param.data.value.toLocaleString() + " (" + Math.ceil(param.percent) + "%)" : "";
            },
        },
        series: [
            {
                type: "pie",
                data: statContent,
                radius: ["0%", "50%"],
                animation: false,
                center: ["35%", "50%"],
                labelLine: {
                    show: false,
                },
                label: {
                    show: false,
                    position: "center",
                },
            },
            {
                type: "pie",
                data: statContentSum,
                radius: ["55%", "95%"],
                animation: false,
                center: ["35%", "50%"],
                labelLine: {
                    show: false,
                },
                label: {
                    show: false,
                    position: "center",
                },
            },
        ],
        legend: {
            show: true,
            data: flyengStyle.seriesClassPlayChartAll.map((s) => s.name),
            x: "right",
            y: "bottom",
            orient: "vertical",
            align: "left",
            formatter: (name) => {
                let s = statContent.find((s) => s.name === name);
                if (s) {
                    return `${name} - ${s.value}`;
                } else {
                    s = statContentSum.find((s) => s.name === name);
                    if (s) {
                        return `${name} - ${s.value}`;
                    }
                }
                return name;
            },
        },
        color: flyengStyle.seriesClassPlayChartAll.map((s) => s.option.itemStyle.color),
    };
    const chartOptionContent = {
        xAxis: { field: "name" },
        yAxis: {
            name: "건",
            series: flyengStyle.seriesClassPlayChart,
        },
        stacks: [{ stack: "base", showSum: false, showSumTooltip: true, showPercent: true }],
        showLegend: true,
        legend: {
            x: "right",
            y: "top"
        },
        sort: false,
        grid: {
            top: "12%",
            left: "10%",
            right: "5%",
            bottom: "10%",
        },
    };
    const chartOptionContentSum = {
        grid: {
            top: "12%",
            left: "10%",
            right: "5%",
            bottom: "10%",
        },
        xAxis: { field: "name" },
        yAxis: {
            name: "건",
            series: flyengStyle.seriesClassPlaySumChart,
        },
        stacks: [{ stack: "base", showSum: false, showSumTooltip: true, showPercent: true }],
        showLegend: true,
        legend: {
            x: "right",
            y: "top",
        },
        sort: false,
    };
    return (
        <div className="stat-branch-content">
            <div className="row mb-3">
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h5 className="card-header-title">접속 경로</h5>
                        </div>
                        <div className="card-body" style={{ height: "auto" }}>
                            <ReactEcharts theme="macarons" option={optionOs} style={{ height: `200px` }} />
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h5 className="card-header-title">콘텐츠 사용 현황</h5>
                        </div>
                        <div className="card-body" style={{ height: "auto" }}>
                            <ReactEcharts theme="macarons" option={optionContent} style={{ height: `200px` }} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h5 className="card-header-title">콘텐츠 순 실행 수</h5>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <CommonHorizontalBarChart chartData={statAge} chartOption={chartOptionContent} />
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h5 className="card-header-title">콘텐츠 누적 실행 수</h5>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <CommonHorizontalBarChart chartData={statAge} chartOption={chartOptionContentSum} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default NurseryContentNursery;
